module.exports = __webpack_public_path__ + "img/daizy_solar.eb2e7769.jpg";